/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown>, n: NonNullable<unknown> }} Perks_SpanInputs */



/**
* | output |
* | --- |
* | "in the last {days} days" |
*
* @param {Perks_SpanInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_span = /** @type {((inputs: Perks_SpanInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_SpanInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") {
		const form = registry.plural("ru", i?.n, {}, true);
		if (form === "one") return /** @type {LocalizedString} */ (`за последний ${i?.days} день`);
		if (form === "few") return /** @type {LocalizedString} */ (`за последние ${i?.days} дня`);
		if (form === "many") return /** @type {LocalizedString} */ (`за последние ${i?.days} дней`);
		return /** @type {LocalizedString} */ (`за последние ${i?.days} дня`)
	}
	return /** @type {LocalizedString} */ (`in the last ${i?.days} days`)
});